class NfeFreteManualModal {
    static get $inject() {
        return ['$filter', 'UsuariosService', 'EfSocket']
    }
    
    constructor(filter, UsuariosService, EfSocket) {
        this.filter = filter
        this.UsuariosService = UsuariosService
        this.EfSocket = EfSocket
    }

    $onInit() {
        this.nfe = this.resolve.nfe
        this.channel = this.resolve.channel
    }

    submit(form) {
        const { valorBaseCalculo, valorIcms } = this.nfe.frete.freteManual

        if (form.$valid) {
            Confirm.warning(
                "Atenção",
                `Deseja informar que o valor do ${this.nfe.valorFrete > 0 ? 'redespacho' : 'CT-e'} vinculado à NF-e
                <strong>${this.nfe.numero}</strong> é igual a <strong>${this.filter("currency")(valorBaseCalculo)}</strong>
                e o valor do ICMS referente ao frete é de <strong>${this.filter("currency")(valorIcms)}</strong>?.
                `,
                {
                    'Eu não desejo': null,
                    'Eu desejo': () => {
                        this.submitPromise = this._socket()
                            .push(this.channel, "informar_frete_manual", { nfe: this.nfe.id, valor_frete_manual: valorBaseCalculo, valor_frete_icms: valorIcms })
                            .then(() => {
                                Alert.success("Valor do CT-e e ICMS informados manualmente com sucesso.", "Sucesso!")

                                this.close({ $value: { valorBaseCalculo, valorIcms } })
                            })
                            .catch(() => Alert.warning("Não foi possível informar o valor do CT-e manualmente.", "Ocorreu um erro."))
                    }
                }
            )
        }
    }

    _socket() {
        return this.EfSocket.socket(this.UsuariosService.token)
    }
}

angular.module('eficienciaFiscalModule')
    .component('nfeFreteManualModal', {
        controller: NfeFreteManualModal,
        bindings: {
            close: '&',
            dismiss: '&',
            resolve: '<'
        },
        template: `
        <form name="form" ng-submit="$ctrl.submit(form)" novalidate="novalidate">
            <div class="modal-header">
                <h3 class="modal-title">
                    Informar valor do frete do CT-e
                    <i tooltip="Fechar" ng-click="$ctrl.dismiss()" class="fa fa-times pull-right cursor-pointer"></i>
                </h3>
            </div>

            <div class="modal-body">
                <section class="clearfix">
                    <div class="form-group col-xs-12"><b>Fornecedor: </b>{{$ctrl.nfe.emitente.nome}}<br>
                        <b>CNPJ:  </b>{{$ctrl.nfe.emitente.cpfCnpj | cpfCnpj}}<br>
                        <b>Número:  </b>{{$ctrl.nfe.numero}} <br>
                    </div>

                    <div class="form-group col-xs-6">
                        <label>Base de cálculo do ICMS
                            <i ng-click="$ctrl.nfe.frete.freteManual.valorBaseCalculo = null"
                                ng-if="$ctrl.nfe.frete.freteManual.valorBaseCalculo" 
                                class="fa fa-trash-o text-danger cursor-pointer">
                            </i>
                        </label>
                        <input ng-model="$ctrl.nfe.frete.freteManual.valorBaseCalculo" money="{prefix:'', centsLimit: 2}" name="valorBaseCalculo" class="form-control" required="required"/>
                        <div ng-messages="form.valorBaseCalculo.$error" ng-messages-multiple="ng-messages-multiple"
                             ng-messages-include="erros-validacao" ng-if="form.$submitted"></div>
                    </div>

                    <div class="form-group col-xs-6">
                        <label>Valor do ICMS
                            <i ng-click="$ctrl.nfe.frete.freteManual.valorIcms = null" 
                                ng-if="$ctrl.nfe.frete.freteManual.valorIcms" 
                                class="fa fa-trash-o text-danger cursor-pointer">
                            </i>
                        </label>
                        <input ng-model="$ctrl.nfe.frete.freteManual.valorIcms" money="{prefix:'', centsLimit: 2}" name="valorIcms"
                                class="form-control" required="required"/>
                        <div ng-messages="form.valorIcms.$error" ng-messages-multiple="ng-messages-multiple"
                             ng-messages-include="erros-validacao" ng-if="form.$submitted"></div>
                    </div>

                    <div class="form-group col-xs-12">
                        Valores informados aqui serão somados aos valores dos CT-e vinculados a esta NF-e.
                    </div>

                    <div class="form-group col-xs-12" ng-if="$ctrl.nfe.frete.freteCte">
                        <i class="fa fa-info-circle"></i>
                        Esta NF-e já possui um frete de 
                        <b>{{ $ctrl.nfe.frete.freteCte.valorBaseCalculo | currency }}</b>
                        vinculado por CT-e. </br>
                    </div>
                </section>
            </div>

            <div class="modal-footer">
                <button type="submit" ng-disabled="$ctrl.submitPromise" class="btn btn-primary">
                    <i class="fa fa-save"></i><span ng-hide="$ctrl.submitPromise"> Salvar</span>
                    <span ng-show="$ctrl.submitPromise">
                        <i class="fa fa-circle-o-notch fa-spin"></i> Salvando...
                    </span>
                </button>
                <button type="button" ng-click="$ctrl.dismiss()" class="btn btn-default">Fechar</button>
            </div>
        </form>
        `
    })
